import * as CONSTANTS from "../../constants";
import {mapBookings} from "../../../services/ConverterService";
import { remove } from 'lodash-es';
import config from "../../../config";

/**
 *  Booking Mutations
 */
export default {

    /**
     * Indicates that getBookings has been called
     *
     * @param state
     */
    [CONSTANTS.BOOKING_FETCH_PENDING](state) {
        state.bookings = {...state.bookings, value: undefined, error: false, loading: true, noContent: false};
    },

    /**
     * Indicates that getBookings has failed
     *
     * @param state
     */
    [CONSTANTS.BOOKING_FETCH_FAILURE](state) {
        state.bookings = {
            ...state.bookings,
            value: undefined,
            error: true,
            loading: false,
            noContent: false,
            hasFetched: true
        };
    },

    /**
     * Indicates that getBookings has succeeded
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_FETCH_SUCCESS](state, payload) {
        // Map the bookings to ensure correct ordering
        state.bookings = {
            ...state.bookings,
            value: mapBookings(payload),
            error: false,
            loading: false,
            noContent: false,
            hasFetched: true
        };
    },

    /**
     * Indicates that getBookings has failed
     *
     * @param state
     */
    [CONSTANTS.BOOKING_FETCH_NO_CONTENT](state) {
        state.bookings = {
            ...state.bookings,
            value: undefined,
            error: false,
            loading: false,
            noContent: true,
            hasFetched: true
        };
    },

    /**
     * Increments the current page
     *
     * @param state
     */
    [CONSTANTS.BOOKING_PAGE_INCREMENT](state) {
        state.bookings.page = state.bookings.page + 1;
    },

    /**
     * Decrements the current page
     *
     * @param state
     */
    [CONSTANTS.BOOKING_PAGE_DECREMENT](state) {
        state.bookings.page = state.bookings.page - 1;
    },

    /**
     * Sets the current page
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_PAGE_SET](state, payload) {
        state.bookings.page = payload;
    },

    /**
     * Updates the predicate to order by
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_PREDICATE_SET](state, payload) {
        state.bookings.predicate = payload;
    },

    /**
     * Sets the limit per page
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_LIMIT_SET](state, payload) {
        state.bookings.limit = payload.data;
    },

    /**
     * Sets the limit per page
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_ORDER_SET](state, payload) {
        state.bookings.order = payload.data;
    },

    /**
     * Indicates that getBookings has been called
     *
     * @param state
     */
    [CONSTANTS.BOOKING_FILTER_PENDING](state) {
        state.bookings.filters = {...state.bookings.filters, loading: true, error: false};
    },

    /**
     * Indicates that getBookings has failed
     *
     * @param state
     */
    [CONSTANTS.BOOKING_FILTER_FAILURE](state) {
        state.bookings.filters = {
            ...state.bookings.filters,
            loading: false,
            error: true,
            brands: undefined,
            domains: undefined,
            countries: undefined,
            sites: undefined,
            accommodations: undefined
        };
    },

    /**
     * Indicates that getBookings has succeeded
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_FILTER_SUCCESS](state, payload) {
        state.bookings.filters = {
            ...state.bookings.filters,
            loading: false,
            error: false,
            brands: payload.brands,
            domains: payload.domains,
            countries: payload.countries,
            sites: payload.sites,
            accommodations: payload.accommodations,
            suppliers: payload.suppliers,
            selectSuppliers: payload.selectSuppliers
        };
        state.bookings.filters.selected = {
            ...state.bookings.filters.selected,
            supplier: payload.selectedSupplier
        };
    },

    [CONSTANTS.BOOKING_SET_SELECTED_FILTERS](state, payload) {
        state.bookings.filters.selected = {...state.bookings.filters.selected, ...payload.data};
    },

    /**
     * Updates the currently selected period
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_SET_BOOKING_PERIOD](state, payload) {
        state.bookings.filters.bookingPeriod = {...state.bookings.filters.bookingPeriod, ...payload.data};
    },

    /**
     * Updates the currently selected period
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_SET_ARRIVAL_PERIOD](state, payload) {
        state.bookings.filters.arrivalPeriod = {...state.bookings.filters.arrivalPeriod, ...payload.data};
    },

    /**
     * Adds the chosen value to the multi dropdown
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_MULTI_PREDICATE_SET](state, payload) {
        state.bookings.predicate.push(payload)
    },

    /**
     * Removes the chosen value form the multi dropdown, if last item then set item to default value
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_MULTI_PREDICATE_UNSET](state, payload) {
        // If deselecting the final item in the dropdown then set to default value
        if (state.bookings.predicate.length === 1) {
            state.bookings.predicate = [state.bookings.defaultPredicate];
        } else {
            state.bookings.predicate = remove(state.bookings.predicate, (p) => {
                return p !== payload;
            })
        }
    },

    /**
     * Reset the multi dropdown.
     *
     * @param state
     */
    [CONSTANTS.BOOKING_MULTI_PREDICATE_RESET](state) {
        state.bookings.predicate = [state.bookings.defaultPredicate];
    },

    /**
     * Select a specific predicate for the multi dropdown
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_MULTI_PREDICATE_SELECT](state, payload) {
        state.bookings.predicate = [payload];
    },

    /**
     * Set the search word.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.BOOKING_FILTER_SEARCH](state, payload) {
        state.bookings.filters.searchword = payload.data;
    },

    /**
     * Set the bookings csv.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.CSV](state, payload) {
        state.bookings.csv = payload
    },

    [CONSTANTS.BOOKING_RESET_STATE](state) {
        state.bookings = {
            ...state.bookings,
            error: undefined,
            noContent: undefined,
            loading: false,
            value: [],
            limit: 20,
            limitList: [5, 10, 20, 50, 100, 200],
            page: 1,
            hasFetched: false,
            predicate: ['supplierRef'],
            defaultPredicate: 'supplierRef',
            predicateList: [
                'supplierRef',
                'bookingRef',
                'status',
                'bookingDate',
                'arrivalDate',
                'departureDate',
                'domain',
                'accommodation',
                'siteName',
                "supplierName"
            ],
            orderList: [
                "asc",
                "desc"
            ],
            order: "asc",
            csv: undefined,
            tips: [
                {
                    title: 'tips.bookingPage.filters.title',
                    body: 'tips.bookingPage.filters.body'
                },
                {
                    title: 'tips.bookingPage.sortList.title',
                    body: 'tips.bookingPage.sortList.body'
                },
                {
                    title: 'tips.bookingPage.downloadList.title',
                    body: 'tips.bookingPage.downloadList.body'
                },
                {
                    title: 'tips.bookingPage.xlsError.title',
                    body: 'tips.bookingPage.xlsError.body'
                },
                {
                    title: 'tips.bookingPage.search.title',
                    body: 'tips.bookingPage.search.body'
                }
            ]
        };
        state.bookings.filters = {
            ...state.bookings.filters,
            searchword: '',
            suppliers: [],
            brands: [],
            domains: [],
            countries: [],
            sites: [],
            accommodations: [],
            status: ['booked', 'pending', 'request', 'rejected', 'request-cancel', 'cancelled', 'unknown'],
            loading: false,
            error: false,
        };
        state.bookings.filters.season = {
            ...state.bookings.filters.season,
            from: config.business.SEASON_DATE_START,
            to: config.business.SEASON_DATE_END
        };
        state.bookings.filters.selected = {
            ...state.bookings.filters.selected,
            country: undefined,
            brand: undefined,
            domain: undefined,
            site: undefined,
            accommodation: undefined,
            status: 'booked'
        };
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/booking/mutations.js